<div class="flex flex-col gap-3">
  <div class="flex flex-col">
    <div class="flex items-center">
      <span class="text-lg">{{ 'pages.campaignForm.sections.basics.financeLabel' | translate }}</span>
    </div>
    <div class="text-shikenso-purple-base-60 text-sm">
      {{ 'pages.campaignForm.sections.basics.financeDescription' | translate }}
    </div>
  </div>

  <div class="flex gap-4" [formGroup]="form()">
    <div class="flex flex-[0.5] flex-col gap-1.5">
      <span class="text-sm font-bold">{{ 'pages.campaignForm.sections.basics.budgetLabel' | translate }}</span>
      <app-budget [control]="form().controls.budget" />
    </div>

    <div class="flex flex-[0.5] flex-col gap-1.5">
      <span class="text-sm font-bold">{{ 'pages.campaignForm.sections.basics.currencyLabel' | translate }}</span>
      <mat-form-field class="w-full">
        <mat-select panelClass="custom-select-panel" formControlName="currency">
          @for (currency of currencies(); track currency.value) {
            <mat-option [value]="currency.value">
              {{ currency.label }}
            </mat-option>
          }
        </mat-select>
        <mat-error [control]="form().get('currency')" />
      </mat-form-field>
    </div>
  </div>
</div>
